import { render, staticRenderFns } from "./LandingPageTips.vue?vue&type=template&id=38e2eb60&scoped=true&"
import script from "./LandingPageTips.vue?vue&type=script&lang=js&"
export * from "./LandingPageTips.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageTips.vue?vue&type=style&index=0&id=38e2eb60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2eb60",
  null
  
)

export default component.exports